<template>
  <div class="login-wrap wrap">
    <h1 :class="['son-title', !loginMethod ? 'center' : '']">
      {{ loginMethod ? $t('login.1') : $t('login.2') }}
    </h1>
    <!-- 登录 -->
    <el-col class="content">
      <el-col class="form-wrap" v-if="loginMethod">
        <el-tabs v-model="tabValue">
          <el-tab-pane :label="$t('825')" name="mobile">
            <el-form :model="ruleForm" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
              <!-- 手机号 -->
              <el-form-item prop="mobile" class="mobile">
                <el-input :placeholder="$t('login.3')" v-model="ruleForm.mobile" class="input-with-select login-input">
                  <el-select
                    v-model="ruleForm.calling_code"
                    slot="prepend"
                    :placeholder="$t('221')"
                    class="login-select"
                  >
                    <el-option label="+66" value="66"></el-option>
                    <el-option label="+62" value="62"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
              <!-- 请输入短信验证码 -->
              <el-form-item prop="verify_code" class="verify_code">
                <el-input
                  :placeholder="$t('login.5')"
                  v-model="ruleForm.verify_code"
                  class="input-with-select login-inner-code"
                />
                <el-button
                  :disabled="!ruleForm.mobile || surplusTime > 0"
                  :class="[ruleForm.mobile ? '' : 'disabled']"
                  type="primary"
                  @click="handleShortCode"
                  >{{ codeText }}</el-button
                >
              </el-form-item>
              <!-- 记住账号 -->
              <el-checkbox v-model="ruleForm.checked" class="checked">{{ $t('login.7') }}</el-checkbox>
              <!-- 登录管理后台 -->
              <gl-button
                :disabled="!isClick"
                class="login-btn"
                @click="handleLogin"
                :loading="loading"
                type="primary"
                >{{ $t('login.6') }}</gl-button
              >
            </el-form>
          </el-tab-pane>
          <el-tab-pane :label="$t('26')" name="email">
            <el-form :model="emailForm" :rules="emailRules" ref="emailForm" label-width="100px" class="demo-ruleForm">
              <!-- 邮箱账号 -->
              <el-form-item prop="email" class="mobile">
                <el-input
                  :placeholder="$t('i18n.f2687684ad8e4fedad5739979750effd')"
                  v-model="emailForm.email"
                  class="input-with-select login-input"
                >
                </el-input>
              </el-form-item>
              <!-- 邮箱验证码 -->
              <el-form-item prop="verify_code" class="verify_code">
                <el-input
                  :placeholder="$t('i18n.bdc0747485374533bf8928d486e76faa')"
                  v-model="emailForm.verify_code"
                  class="input-with-select login-inner-code"
                />
                <el-button
                  type="primary"
                  :class="[emailForm.email ? '' : 'disabled']"
                  :disabled="!emailForm.email"
                  :loading="queryLoading"
                  @click="handleQueryEmailCode"
                  >{{ $t('login.4') }}</el-button
                >
              </el-form-item>
              <!-- 记住账号 -->
              <el-checkbox v-model="emailForm.checked" class="checked">{{ $t('login.7') }}</el-checkbox>
              <!-- 登录管理后台 -->
              <gl-button
                :disabled="loginButtonDisabled"
                :loading="loginLoading"
                class="login-btn"
                type="primary"
                @click="handleEmailLogin"
                >{{ $t('login.6') }}</gl-button
              >
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <!-- 扫码登录 -->
      <el-col class="qr-code-wrap" v-if="!loginMethod">
        <span v-if="isRefresh === 2" class="qr-success">
          <img src="@/assets/img/icon_qr.png" alt="" />
          <p>{{ $t('login71') }}</p>
        </span>
        <span class="qr-img" v-else>
          <img :src="qrCode.data_uri" alt="QR-CODE" :loading-text="$t('989')" />
          <div
            class="mask"
            v-if="isRefresh === 1"
            v-loading="qrCodeLoading"
            element-loading-background="rgba(0, 0, 0, 0.52)"
          ></div>
          <div class="content" @click="handleGetQrCode(true)" v-if="isRefresh === 1 && !qrCodeLoading">
            <img src="@/assets/img/icon_refresh.png" alt="" />
            <p>{{ $t('252') }}</p>
          </div>
        </span>

        <p class="warn-text warn" v-if="isRefresh === 2">
          {{ $t('login.39') }} <span>{{ $t('login.32') }} </span>{{ $t('login.40') }}
        </p>
        <p class="warn-text" v-else>
          {{ $t('login.31') }} <span>{{ $t('login.32') }}</span> {{ $t('login.2') }}
        </p>
      </el-col>
    </el-col>
    <!-- 切换登录方式 -->
    <div class="qr-code" @click="handleChangeLoginMethod" @mouseleave="onMouseleave" @mouseenter="onMouseenter">
      <img :src="loginMethod ? changeImageUrl[0] : changeImageUrl[1]" alt />
    </div>
  </div>
</template>

<script>
// 获取图片验证码
import { getShortCode } from 'api/common'
// 登录api
import { login, getQrCode, QrStatus } from 'api/login'
import { utilCookies } from '@/util/cookies' // token操作
// button
import GlButton from '@/components/gl-button'
export default {
  components: {
    GlButton
  },
  data() {
    const str = utilCookies.getLanguage() || 'en'
    return {
      lang: str,
      // 图片验证码
      codeImg: '',
      // 二维码
      qrCode: {},
      qrCodeLoading: false,
      // 登录方式 true 手机号登录  false 二维码登录
      loginMethod: true,
      changeImageUrl: [require('@/assets/img/qrcode.png'), require('@/assets/img/mac.png')],
      disabled: {
        sendCode: false
      },
      surplusTime: 0,
      play: null,
      isRefresh: 0,
      // 表单数据
      ruleForm: {
        calling_code: '66',
        verify_code: '',
        mobile: '',
        checked: !!localStorage.getItem('loginInfo')
      },
      // 校验规则
      rules: {
        mobile: [{ required: true, message: this.$t('login.35'), trigger: 'blur' }],
        verify_code: [{ required: true, message: this.$t('login.36'), trigger: 'blur' }]
      },
      // 按钮loading
      loading: false,
      // ---------------邮箱登录相关state数据定义---------------
      tabValue: 'mobile',
      queryLoading: false,
      loginLoading: false,
      emailForm: {
        email: '',
        verify_code: '',
        checked: !!localStorage.getItem('loginInfoByEmail')
      },
      emailRules: {
        email: [{ required: true, message: this.$t('i18n.74db18635ea44101b6434a93669138c9'), trigger: 'blur' }],
        verify_code: [{ required: true, message: this.$t('login.36'), trigger: 'blur' }]
      }
    }
  },
  created() {
    this.init()
  },
  computed: {
    isClick() {
      const { calling_code, verify_code, mobile } = this.ruleForm
      const status = calling_code && verify_code && mobile
      return status
    },
    loginButtonDisabled() {
      const { email, verify_code } = this.emailForm
      const disabled = !email || !verify_code
      return disabled
    },
    codeText() {
      if (this.surplusTime === -1) {
        return this.$t('login.4')
      }
      if (this.surplusTime === -2) {
        return this.$t('login.10')
      }
      return this.surplusTime > 0 ? `${this.surplusTime}S` : this.$t('login.4')
    }
  },
  methods: {
    init() {
      this.agreeUrl = `https://api.pophr.com/auth/tool/terms?lang=${this.lang}`
      // 判断是否存在token
      if (utilCookies.getToken()) {
        this.$router.push('loginCompany')
      }
      // 是否记住密码 为true说明有设置localStorage
      if (this.ruleForm.checked) {
        const loginInfo = JSON.parse(localStorage.getItem('loginInfo'))
        this.ruleForm.mobile = loginInfo.mobile
      }
      if (this.emailForm.checked) {
        const loginInfo = JSON.parse(localStorage.getItem('loginInfoByEmail'))
        this.emailForm.email = loginInfo.email
      }
      // 是否可以发送验证码 全局mixin方法
      this.resetTimeCode(time => {
        if (time <= 0) {
          this.disabled.sendCode = false
        }
        this.surplusTime = time
      })
    },
    // 短信验证码
    handleShortCode() {
      // 校验是否输入图片验证码和手机号
      if (this.ruleForm.mobile) {
        this.surplusTime = -1
        getShortCode(this.ruleForm)
          .then(res => {
            if (res && res.code === 1) {
              // 获取短信验证码埋点
              // this.$ga.event('FHRLogin', 'click', 'GetVerificationCode', 3)
              this.$s.set('codeTime', new Date().getTime())
              this.$message({
                message: this.$t('login.33'),
                type: 'success'
              })
              // 全局mixin方法
              this.resetTimeCode(time => {
                if (time <= 0) {
                  this.disabled.sendCode = false
                }
                this.surplusTime = time
              })
            }
          })
          .catch(() => {
            // 还原发送验证码
            this.surplusTime = -2
          })
      } else {
        this.$message({
          message: this.$t('login.37'),
          type: 'error'
        })
      }
    },
    // 查询邮箱验证码
    handleQueryEmailCode() {
      this.queryLoading = true
      this.$http({
        url: '/auth/app/emailCaptcha',
        data: {
          email: this.emailForm.email,
          type: 1
        }
      })
        .then(() => {
          this.$message({
            message: this.$t('login.33'),
            type: 'success'
          })
        })
        .finally(() => {
          this.queryLoading = false
        })
    },
    onMouseleave() {
      this.changeImageUrl = [require('@/assets/img/qrcode.png'), require('@/assets/img/mac.png')]
    },
    onMouseenter() {
      this.changeImageUrl = [require('@/assets/img/qrcode1.png'), require('@/assets/img/mac1.png')]
    },
    onAgree() {
      // 用户服务协议+使用条款埋点
      // this.$ga.event('FHRLogin', 'click', 'UserTerms', 12)
    },
    // 账号登录
    handleLogin() {
      // 表单必填项验证
      this.$refs.form.validate(valid => {
        if (valid) {
          // 登录管理后台埋点
          // this.$ga.event('FHRLogin', 'click', 'LoginConsoleButton', 4)
          // 是否记住密码 为true则设置localStorage，为false则删除
          if (this.ruleForm.checked) {
            localStorage.setItem('loginInfo', JSON.stringify(this.ruleForm))
          } else {
            if (localStorage.getItem('loginInfo')) {
              localStorage.removeItem('loginInfo')
            }
          }
          this.loading = true
          const msg = JSON.parse(JSON.stringify(this.ruleForm))
          login(msg)
            .then(res => {
              if (res && res.code === 1) {
                this.$s.set('userInfo', res.data.user_info)
                utilCookies.setToken(res.data.access_token)
                if (res.data.managed) {
                  window.location.reload()
                } else {
                  this.$router.push({
                    path: '/login/loginWarning'
                  })
                }
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    // 邮箱登录
    handleEmailLogin() {
      // 表单必填项验证
      this.$refs.emailForm.validate(valid => {
        if (valid) {
          // 登录管理后台埋点
          // this.$ga.event('FHRLogin', 'click', 'LoginConsoleButton', 4)
          // 是否记住密码 为true则设置localStorage，为false则删除
          if (this.emailForm.checked) {
            localStorage.setItem('loginInfoByEmail', JSON.stringify(this.emailForm))
          } else {
            if (localStorage.getItem('loginInfoByEmail')) {
              localStorage.removeItem('loginInfoByEmail')
            }
          }
          this.loginLoading = true
          login(this.emailForm)
            .then(res => {
              if (res && res.code === 1) {
                this.$s.set('userInfo', res.data.user_info)
                utilCookies.setToken(res.data.access_token)
                if (res.data.managed) {
                  window.location.reload()
                } else {
                  this.$router.push({
                    path: '/login/loginWarning'
                  })
                }
              }
            })
            .finally(() => {
              this.loginLoading = false
            })
        }
      })
    },
    // 获取二维码
    handleGetQrCode(status) {
      // play存在先删除定时器
      if (this.play) clearInterval(this.play)
      // 遮罩层不展示
      this.isRefresh = 0
      // status 是为了判断初始化 还是更新验证阿么
      this.qrCodeLoading = true
      getQrCode().then(res => {
        if (res && res.code === 1) {
          this.qrCode = res.data
          this.qrCodeLoading = false
          const self = this
          // 监听二维码登录状态
          if (status) {
            this.play = setInterval(() => {
              if (self.loginMethod || this.isRefresh === 1) return clearInterval(self.play)
              QrStatus(this.qrCode).then(res => {
                if (res && res.code === 1) {
                  this.isRefresh = 0
                  this.$s.set('userInfo', res.data.user_info)
                  utilCookies.setToken(res.data.access_token)
                  window.location.reload()
                }
                if (res && res.data) {
                  if (res.data.state === 9) this.isRefresh = 1
                  if (res.data.state === 2) this.isRefresh = 2
                }
              })
            }, 1000)
          }
        }
      })
    },
    // 切换登录方式
    handleChangeLoginMethod() {
      // 切换右上角登录方式埋点
      // this.$ga.event('FHRLogin', 'click', this.loginMethod ? 'ScanQR' : 'TelLogin', 1)
      this.loginMethod = !this.loginMethod
      if (!this.loginMethod) this.handleGetQrCode(true) // 获取验证码
    }
  }
}
</script>
